import { EHChangeCrossCursor, EHGenLine, EventGraphBase, EventGraphNode, EventGraphNodeNotice, EventGraphNodeRender, EventHandlerCalPointerDown, EventHandlerCalPointerMove, EventHandlerCalPrimitiveInView, EventHandlerCalTempLine, EventHandlerCapture, EventHandlerCmdEnd, EventHandlerConfirm, EventHandlerDisableSelect, EventHandlerGeneratePri, EventHandlerGrid, EventHandlerInitCapture, EventHandlerNumberInput, EventHandlerOrthoPolar, EventHandlerSettingOrthoPoint, EventHandlerStart, NeedInputEnum, PythaEventName, UpdateType } from "pytha2";
import { EHTestRender } from "./EHTestRender";


/**
 * 绘制轴线
 */
export class EGTest extends EventGraphBase {

    /**
     * 前端测试图
     */
    static cmd = 'OUTTEST';

    /**
     * 创建图
     */
    generate() {

        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerGrid);
        const node3 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node4 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node5 = new EventGraphNode(this, EHTestRender);
        
        this.addEdge(node1, node5);
        this.addEdge(node5, node2);
        this.addEdge(node2, node4);
        this.addEdge(node4, node3);
        
        // 指定初始状态下的当前节点和头节点
        this.currentPointers =[node1];
        this.head = node1;
        
        // https://event.graph.tncet.com/graphs/86
    }
}
